<template>
  <div class="general-complaint-list">
    <pageHeaderView></pageHeaderView>
    <Card class="content">
      <div class="card-header">
        <div class="card-header-text">投诉举报信息</div>
        <div class="card-header-divider"></div>
      </div>
      <div class="box-header">
        <div class="box-header-left">
          <city-select-list style="display:inline-block" :city="region" @selectCity="selectCity"></city-select-list>
          <div class="status-filter">
            <Select v-model="status">
              <Option :value="-1">状态：不限</Option>
              <Option :value="0">待处理</Option>
              <Option :value="1">办理中</Option>
              <Option :value="2">已办结</Option>
              <Option :value="3">已关闭</Option>
            </Select>
          </div>
          <div class="domain-filter">
            <Select v-model="domain">
              <Option value="">领域：不限</Option>
              <Option value="农民工工资">农民工工资</Option>
              <Option value="社保经办">社保经办</Option>
              <Option value="社会保险">社会保险</Option>
              <Option value="和谐劳动关系">和谐劳动关系</Option>
              <Option value="事业单位人事管理和工资福利">事业单位人事管理和工资福利</Option>
              <Option value="人才评价开发">人才评价开发</Option>
              <Option value="其他">其他</Option>
            </Select>
          </div>
          <div class="field-filter">
            <Select v-model="field">
              <Option :value="-1">类型：不限</Option>
              <Option
                v-for="(f,fIdx) in subField" :key="fIdx"
                :value="f.value">{{ f.label }}</Option>
            </Select>
          </div>
        </div>
        <div class="box-tools">
          <div style="display: inline-block;margin-right:15px;" @mouseenter="toggleSearch(true)" @mouseleave="toggleSearch(false)">
            <Select v-model="searchBy" class="table-search" :class="{on: tableSearchOn||searchMode||searchBy}">
              <Option value="">不限</Option>
              <Option :value="col.searchKey?col.searchKey:col.key" v-for="col in columns.filter((c)=>{return c.title && c.searchable})" :key="col.key">{{col.title}}</Option>
            </Select>&nbsp;
            <Input v-model="keyword" ref="tableSearch" placeholder="搜索关键字" @on-focus="toggleSearchMode" @on-blur="toggleSearchMode" class="table-search" :class="{on: tableSearchOn||searchMode||keyword}"></Input>&nbsp;
            <Button type="default" icon="ios-search" @click="search"></Button>
          </div>
          <Button-group>
            <Button type="default" icon="md-refresh" @click="refreshList">刷新</Button>
          </Button-group>
        </div>
      </div>
      <div class="box-body">
        <Table stripe :columns="columns" :data="data" ref="table" @on-selection-change="selectRowChange"></Table>
        <div style="margin: 10px;overflow: hidden">
          <Button type="primary" size="large" @click="exportData" :disabled="!rowSelected"><Icon type="ios-download-outline"></Icon> 导出原始数据</Button>
          <div style="float: right;">
            <Page :total="totalCount" :page-size-opts="[10,20,50,100]" @on-change="changePage" @on-page-size-change="changePageSize" :current="pageCurrent" show-sizer></Page>
          </div>
        </div>
        <Modal v-model="modalDetail" @on-cancel="closeDetailModal" width="720">
          <p slot="header">
            <Icon type="information-circled"></Icon>
            <span>查看详情</span>
          </p>
          <div class="detail-view" v-if="dataSelected&&dataSelected.ComplainantName">
            <table class="detail-table">
              <tr>
                <th width="200">所属地区</th>
                <td>{{ dataSelected.RegionFullName }}</td>
              </tr>
              <tr>
                <th width="200">领域</th>
                <td>{{ dataSelected.Domain }}</td>
              </tr>
              <tr>
                <th width="200">类型</th>
                <td>{{ getFieldName(dataSelected.Domain, dataSelected.Field) }}</td>
              </tr>
              <tr>
                <th width="200">状态</th>
                <td>
                  <Tag :color="$common.generalComplaintStatusColor[dataSelected.Status.toString()]">{{ $common.generalComplaintStatus[dataSelected.Status.toString()] }}</Tag>
                </td>
              </tr>
              <tr>
                <th width="200">反映人姓名</th>
                <td>{{ dataSelected.ComplainantName }}</td>
              </tr>
              <tr>
                <th width="200">反映人身份证号</th>
                <td>{{ dataSelected.ComplainantIDNumber }}</td>
              </tr>
              <tr>
                <th width="200">反映人联系电话</th>
                <td>{{ dataSelected.ComplainantMobile }}</td>
              </tr>
              <tr v-if="dataSelected.Domain==='农民工工资'">
                <th width="200">拖欠工资项目名称</th>
                <td>{{ dataSelected.ProjectName }}</td>
              </tr>
              <tr v-if="dataSelected.Domain==='农民工工资'">
                <th width="200">欠薪单位名称</th>
                <td>{{ dataSelected.CompanyName }}</td>
              </tr>
              <tr v-else>
                <th width="200">被投诉单位名称</th>
                <td>{{ dataSelected.CompanyName }}</td>
              </tr>
              <tr v-if="dataSelected.Domain==='农民工工资'">
                <th width="200">欠薪负责人名称</th>
                <td>{{ dataSelected.PrincipalName }}</td>
              </tr>
              <tr v-if="dataSelected.Domain==='农民工工资'">
                <th width="200">欠薪负责人电话</th>
                <td>{{ dataSelected.PrincipalTel }}</td>
              </tr>
              <tr v-if="dataSelected.Domain==='农民工工资'">
                <th width="200">欠薪人数</th>
                <td>{{ dataSelected.ComplainantPersonCount }}</td>
              </tr>
              <tr v-if="dataSelected.Domain==='农民工工资'">
                <th width="200">欠薪金额</th>
                <td>{{ Math.round(dataSelected.Amount / 10000) / 100 }}万元</td>
              </tr>
              <tr v-if="dataSelected.Domain==='农民工工资'">
                <th width="200">欠薪时间</th>
                <td>{{ $moment(dataSelected.OccurDate).format('YYYY-MM-DD') }}</td>
              </tr>
              <tr v-if="dataSelected.Domain==='农民工工资'">
                <th width="200">欠薪基本情况</th>
                <td><div class="pre">{{ dataSelected.Content }}</div></td>
              </tr>
              <tr v-else>
                <th width="200">反映情况内容</th>
                <td><div class="pre">{{ dataSelected.Content }}</div></td>
              </tr>
              <tr v-if="dataSelected.AttachmentImgs&&dataSelected.AttachmentImgs.length">
                <th width="200">佐证材料</th>
                <td>
                  <ul class="report-files">
                    <li class="report-file preview-img"
                      :style="{ backgroundImage: 'url(' + img.ImgUrl + ')' }"
                      @click="openGallery(idx)"
                      v-for="img, idx in dataSelected.AttachmentImgs"
                      :key="idx">
                    </li>
                  </ul>
                  <LightBox ref="Lightbox" id="complaintLightBox"
                    :media="dataSelected.ImgSrcArr"
                    :showLightBox="showLightBox"
                    :showCaption="false"
                    :showThumbs="true">
                  </LightBox>
                </td>
              </tr>
              <tr>
                <th width="200">上报时间</th>
                <td>{{ $moment(dataSelected.CreateTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
              </tr>
              <tr v-if="dataSelected.Status===2">
                <th width="200">处理结果</th>
                <td><div class="pre">{{ dataSelected.Result }}</div></td>
              </tr>
              <tr v-if="dataSelected.Status===2">
                <th width="200">办结时间</th>
                <td>{{ $moment(dataSelected.DoneTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
              </tr>
              <tr v-if="dataSelected.Status===3">
                <th width="200">关闭时间</th>
                <td>{{ $moment(dataSelected.DoneTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
              </tr>
            </table>
          </div>
        </Modal>
        <Modal v-model="modalDoing" width="360">
          <p slot="header">
            <Icon type="information-circled"></Icon>
            <span>确认办理</span>
          </p>
          <div style="text-align:center">
            <p>是否确认办理此投诉？</p>
          </div>
          <div slot="footer">
            <Button type="primary" size="large" long :loading="modal_loading" @click="doing">办理</Button>
          </div>
        </Modal>
        <Modal v-model="modalDone" width="640">
          <p slot="header">
            <Icon type="information-circled"></Icon>
            <span>处理结果</span>
          </p>
          <div>
            <Form ref="doneForm" :model="modalDoneModel" :rules="ruleDoneValidate" :label-width="110">
              <Form-item label="处理结果" prop="Result">
                <Input type="textarea" v-model="modalDoneModel.Result" :autosize="{minRows: 10}" placeholder="请输入处理结果"></Input>
              </Form-item>
            </Form>
          </div>
          <div slot="footer">
            <Button type="warning" size="large" long :loading="modal_loading" @click="modalDoneConfirm">确认办结</Button>
          </div>
        </Modal>
        <Modal v-model="modalDoneConfirmed" width="360">
          <p slot="header">
            <Icon type="information-circled"></Icon>
            <span>确认办结</span>
          </p>
          <div style="text-align:center">
            <p>是否确认此投诉已办结？</p>
          </div>
          <div slot="footer">
            <Button type="warning" size="large" long :loading="modal_loading" @click="done">确认办结</Button>
          </div>
        </Modal>
        <Modal v-model="modalClose" width="360">
          <p slot="header">
            <Icon type="information-circled"></Icon>
            <span>确认关闭</span>
          </p>
          <div style="text-align:center">
            <p>是否确认关闭此投诉？</p>
          </div>
          <div slot="footer">
            <Button type="error" size="large" long :loading="modal_loading" @click="close">办理</Button>
          </div>
        </Modal>
        <Modal v-model="modalTransfer" width="360">
          <p slot="header">
            <Icon type="information-circled"></Icon>
            <span>移交投诉</span>
          </p>
          <div style="text-align:center">
            <p>移交此投诉给：</p>
            <city-select-list :city="transferRegion" @selectCity="transferSelectCity"></city-select-list>
          </div>
          <div slot="footer">
            <Button type="primary" size="large" long :loading="modal_loading" @click="modalTransferConfirm=true">移交</Button>
          </div>
        </Modal>
        <Modal v-model="modalTransferConfirm" width="360">
          <p slot="header">
            <Icon type="information-circled"></Icon>
            <span>确认移交</span>
          </p>
          <div style="text-align:center">
            <p>是否确认移交此投诉？</p>
          </div>
          <div slot="footer">
            <Button type="warning" size="large" long :loading="modal_loading" @click="transfer">确认移交</Button>
          </div>
        </Modal>
      </div>
    </Card>
  </div>
</template>

<script>
import pageHeaderView from '../public/PageHeader'
import citySelectList from '../public/CitySelectList'
import * as XLSX from 'xlsx'
import LightBox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
export default {
  name: 'general-complaint-list',
  components: {
    pageHeaderView,
    citySelectList,
    LightBox
  },
  data () {
    return {
      datatableData: [],
      loading: false,
      dataSelected: {
        Tid: null,
        ComplainantName: null,
        AttachmentImgs: [],
        Attachments: [],
        ImgSrcArr: []
      },
      modal_loading: false,
      modalDelete: false,
      modalDetail: false,
      modalDoing: false,
      modalDoneConfirmed: false,
      modalDoneModel: {
        Tid: null,
        Result: null
      },
      ruleDoneValidate: {
        Result: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      },
      modalDone: false,
      modalClose: false,
      rowSelected: false,
      rowSelectedList: [],
      pageCurrent: 1,
      pageSize: 10,
      keyword: '',
      searchBy: '',
      searchMode: false,
      tableSearchOn: false,
      columns: [
        { type: 'selection', width: 60, align: 'center' },
        {
          title: '#',
          key: 'Tid',
          width: 80
        },
        {
          title: '所属地区',
          key: 'RegionFullName',
          width: 240,
          ellipsis: true
        },
        {
          title: '所属领域',
          key: 'Domain',
          width: 120,
          render: (h, params) => {
            return h('span', {}, params.row.Domain)
          }
        },
        {
          title: '类型',
          key: 'Field',
          width: 160,
          render: (h, params) => {
            return h('span', {}, this.getFieldName(params.row.Domain, params.row.Field))
          }
        },
        {
          title: '状态',
          key: 'Status',
          width: 120,
          render: (h, params) => {
            return h('Tag', {
              props: {
                // type: 'dot',
                color: this.$common.generalComplaintStatusColor[params.row.Status.toString()]
              }
            }, this.$common.generalComplaintStatus[params.row.Status.toString()])
          }
        },
        {
          title: '被投诉单位',
          key: 'CompanyName',
          width: 240,
          ellipsis: true,
          searchable: true
        },
        {
          title: '反映人',
          key: 'ComplainantName',
          width: 120,
          ellipsis: true,
          searchable: true
        },
        {
          title: '反映人电话',
          key: 'ComplainantMobile',
          width: 120,
          ellipsis: true,
          searchable: true,
          render: (h, params) => {
            return h('span', {}, params.row.ComplainantMobile)
          }
        },
        {
          title: '投诉基本情况',
          key: 'Content',
          render: (h, params) => {
            let content = this.getContent(params.row)
            return h('span', {
              class: 'font-grey'
            }, content)
          }
        },
        {
          title: '上报时间',
          key: 'CreateTime',
          width: 160,
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.CreateTime).format('YYYY-MM-DD'))
          }
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 260,
          render: (h, params) => {
            return this.getActionBtns(h, params.row)
          }
        }
      ],
      data: [],
      region: null,
      province: 0,
      municipality: 0,
      county: 0,
      totalCount: 0,
      pageTotal: 0,
      status: -1,
      domain: '',
      modalTransferConfirm: false,
      modalTransfer: false,
      modalTransferModel: {
        Tid: null,
        Province: null,
        ProvinceName: null,
        Municipality: null,
        MunicipalityName: null,
        County: null,
        CountyName: null
      },
      transferRegion: null,
      showLightBox: false,
      field: -1,
      subFields: [
        {
          domain: '社保经办',
          fields: [
            {
              value: 101,
              label: '企业职工退休类'
            },
            {
              value: 102,
              label: '机关事业单位人员退休类'
            },
            {
              value: 103,
              label: '失业待遇类'
            },
            {
              value: 104,
              label: '工伤待遇类'
            },
            {
              value: 105,
              label: '参保登记类'
            },
            {
              value: 106,
              label: '社保补缴类'
            },
            {
              value: 107,
              label: '其他'
            }
          ]
        },
        {
          domain: '社会保险',
          fields: [
            {
              value: 201,
              label: '特殊工种提前退休类'
            },
            {
              value: 202,
              label: '工伤认定类'
            },
            {
              value: 203,
              label: '失业保险类'
            },
            {
              value: 204,
              label: '城乡居民养老保险类'
            },
            {
              value: 205,
              label: '劳动能力鉴定类'
            },
            {
              value: 206,
              label: '其他'
            }
          ]
        },
        {
          domain: '和谐劳动关系',
          fields: [
            {
              value: 301,
              label: '劳动者权益保障(工作时间、休息休假）类'
            },
            {
              value: 302,
              label: '调解仲裁类'
            },
            {
              value: 303,
              label: '劳务派遣纠纷类'
            },
            {
              value: 304,
              label: '企业非法用工类'
            },
            {
              value: 305,
              label: '其他'
            }
          ]
        },
        {
          domain: '事业单位人事管理和工资福利',
          fields: [
            {
              value: 401,
              label: '事业单位人员工资福利类'
            },
            {
              value: 402,
              label: '事业单位人事管理类'
            },
            {
              value: 403,
              label: '其他'
            }
          ]
        },
        {
          domain: '人才评价开发',
          fields: [
            {
              value: 501,
              label: '职称评审类'
            },
            {
              value: 502,
              label: '职业能力建设类'
            },
            {
              value: 503,
              label: '专业技术人员管理类'
            },
            {
              value: 504,
              label: '职业技能鉴定类'
            },
            {
              value: 505,
              label: '人事档案管理类'
            },
            {
              value: 506,
              label: '人事考试类'
            },
            {
              value: 507,
              label: '其他'
            }
          ]
        },
        {
          domain: '其他',
          fields: [
            {
              value: 601,
              label: '社保卡'
            },
            {
              value: 602,
              label: '小额贷款'
            },
            {
              value: 609,
              label: '其他'
            },
          ]
        },
        {
          domain: '农民工工资',
          fields: [
            {
              value: 1,
              label: '工程建设'
            },
            {
              value: 0,
              label: '非工程建设'
            }
          ]
        }
      ],
    }
  },
  watch: {
    status: function () {
      this.pageCurrent = 1
      this.initDataTable()
    },
    '$route.query.domain' (newVal) {
      this.domain = newVal
      this.pageCurrent = 1
      this.field = -1
      this.initDataTable()
    },
    domain: function () {
      this.pageCurrent = 1
      this.field = -1
      this.initDataTable()
    },
    field: function () {
      this.pageCurrent = 1
      this.initDataTable()
    },
    modalDetail: function (newVal) {
      if (newVal) {
        if (this.dataSelected && this.dataSelected.ComplainantName) {
          if (this.dataSelected.AttachmentImgs && this.dataSelected.AttachmentImgs.length) {
            return true
          }
          if (this.dataSelected.Attachments && this.dataSelected.Attachments.length) {
            this.procAttachments(this.dataSelected)
            this.$nextTick()
          }
        }
      }
    }
  },
  computed: {
    subField () {
      if (this.domain) {
        let sub = this.subFields.find(o => o.domain === this.domain)
        if (sub) {
          return sub.fields
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  mounted () {
    this.$store.dispatch('setPageStore', {
      pageHeader: '举报投诉信息',
      pageDescr: '全部列表'
    })
    if (this.$route.query.domain) {
      this.domain = this.$route.query.domain
    }
    this.initDataTable()
  },
  methods: {
    getActionBtns (h, row) {
      let btns = [
        h('Button', {
          props: {
            type: 'default',
            size: 'small',
          },
          style: {
            marginRight: '5px'
          },
          on: {
            click: () => {
              this.dataSelected = Object.assign(this.dataSelected, row)
              this.modalDetail = true
            }
          }
        }, '详情')
      ]
      if (row.Status === 0) {
        btns.push(h('Button', {
          props: {
            type: 'default',
            size: 'small',
            ghost: false
          },
          style: {
            marginRight: '5px'
          },
          on: {
            click: () => {
              this.dataSelected = row
              this.transferRegion = row.Region
              this.modalTransferModel = {
                Tid: row.Tid,
                Province: row.Province,
                ProvinceName: row.ProvinceName,
                Municipality: row.Municipality,
                MunicipalityName: row.MunicipalityName,
                County: row.County,
                CountyName: row.CountyName
              }
              this.modalTransfer = true
            }
          }
        }, '移交'))
        btns.push(h('Button', {
          props: {
            type: 'primary',
            size: 'small',
            ghost: true
          },
          style: {
            marginRight: '5px'
          },
          on: {
            click: () => {
              this.dataSelected = row
              this.modalDoing = true
            }
          }
        }, '办理'))
        btns.push(h('Button', {
          props: {
            type: 'warning',
            size: 'small',
            ghost: true
          },
          style: {
            marginRight: '5px'
          },
          on: {
            click: () => {
              console.log(row, this.modalDoneModel)
              this.dataSelected = row
              this.modalDoneModel = {
                Tid: row.Tid,
                Result: null
              }
              console.log(row, this.modalDoneModel)
              this.modalDone = true
            }
          }
        }, '办结'))
        btns.push(h('Button', {
          props: {
            type: 'error',
            size: 'small',
            ghost: true
          },
          style: {
            marginRight: '5px'
          },
          on: {
            click: () => {
              this.dataSelected = row
              this.modalClose = true
            }
          }
        }, '关闭'))
      } else if (row.Status === 1) {
        btns.push(h('Button', {
          props: {
            type: 'warning',
            size: 'small',
            ghost: true
          },
          style: {
            marginRight: '5px'
          },
          on: {
            click: () => {
              this.dataSelected = row
              this.modalDoneModel = {
                Tid: row.Tid,
                Result: null
              }
              this.modalDone = true
            }
          }
        }, '办结'))
        btns.push(h('Button', {
          props: {
            type: 'error',
            size: 'small',
            ghost: true
          },
          style: {
            marginRight: '5px'
          },
          on: {
            click: () => {
              this.dataSelected = row
              this.modalClose = true
            }
          }
        }, '关闭'))
      }
      return btns
    },
    getFieldName (domain, field) {
      if (domain) {
        let sub = this.subFields.find(o => o.domain === domain)
        if (sub) {
          let f = sub.fields.find(o => o.value === field)
          if (f) {
            return f.label
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    selectCity (value) {
      this.region = value
      if (value && value.length > 0) {
        this.province = parseInt(value.substr(0, 2))
        this.municipality = parseInt(value.substr(2, 2))
        this.county = parseInt(value.substr(4, 2))
        this.initDataTable()
      } else {
        this.province = 0
        this.municipality = 0
        this.county = 0
        this.initDataTable()
      }
    },
    initDataTable (query = {}) {
      let queryModel = {
        PageIndex: this.pageCurrent,
        PageSize: this.pageSize,
        Province: this.province,
        Municipality: this.municipality,
        County: this.county,
        Status: this.status,
        Field: this.field,
        Domain: this.domain
      }
      Object.assign(queryModel, query)
      this.$Spin.show()
      this.$Api.Project.getGeneralComplaintList(queryModel).then((respBody) => {
        this.pageTotal = respBody.PageCount
        this.totalCount = respBody.TotalCount
        this.$Spin.hide()
        this.data = respBody.List
      })
      .catch(err => {
        this.$Spin.hide()
        this.$Notice.error({
          title: '获取列表失败!',
          desc: err.message
        })
      })
    },
    getContent (row) {
      let content = ''
      if (row.Content.length >= 60) {
        content = row.Content.substr(0, 60) + '...'
      } else {
        content = row.Content
      }
      return content
    },
    closeComplaintDetail () {
      this.modalDetail = false
    },
    selectRowChange (selection) {
      if (selection.length > 0) {
        this.rowSelected = true
        this.rowSelectedList = selection
      } else {
        this.rowSelected = false
        this.rowSelectedList = []
      }
    },
    changePage (page) {
      this.pageCurrent = page
      this.initDataTable()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.initDataTable()
    },
    exportData1 () {
      let data = this.rowSelectedList.map((r) => {
        return r
      })
      this.$refs.table.exportCsv({
        filename: 'zztdata.csv',
        columns: this.columns,
        data: this.formatExcelData(data)
      })
    },
    exportData () {
      let data = this.rowSelectedList.map((r) => {
        return r
      })
      let rows = data.map((d) => {
        return {
          ID: d.Tid,
          所属地区: d.RegionFullName,
          所属领域: d.Domain,
          类型: this.getFieldName(d.Domain, d.Field),
          状态: this.$common.generalComplaintStatus[d.Status.toString()],
          反映人: d.ComplainantName,
          反映人身份证号: d.ComplainantIDNumber,
          反映人电话: d.ComplainantMobile,
          投诉基本情况: `'${d.Content}'`,
          上报日期: this.$moment(d.CreateTime).format('YYYY-MM-DD HH:mm:ss')
        }
      })
      const worksheet = XLSX.utils.json_to_sheet(rows)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '导出')
      XLSX.writeFile(workbook, `投诉列表导出@${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`, { compression: true })
    },
    formatExcelData (data) {
      let arr = []
      data.forEach((v) => {
        for (var k in v) {
          if (typeof v[k] == 'string') {
            v[k] = '"'+ v[k].replace(/"/g, '""')+'"'
          }
        }
        arr.push(v)
      })
      return arr
    },
    modalDoneConfirm () {
      this.$refs['doneForm'].validate((valid) => {
        if (valid) {
          this.modalDoneConfirmed = true
        } else {
          this.$Message.error('表单验证失败!')
        }
      })
    },
    async done () {
      this.modal_loading = true
      await this.$Api.Project.setGeneralComplaintDone(this.modalDoneModel)
        .then(() => {
          this.$Message.success('操作成功')
          let item = this.data.find(o => o.Tid === this.modalDoneModel.Tid)
          item.Status = 2
          item.Result = this.modalDoneModel.Result
          item.DoneTime = this.$moment().format('YYYY-MM-DD HH:mm:ss')
          this.modalDoneModel = {
            Tid: null,
            Result: null
          }
        })
        .catch((err) => {
          this.$Message.error('操作失败！' + err.message)
        })
      this.modal_loading = false
      this.modalDone = false
      this.modalDoneConfirmed = false
    },
    async doing () {
      this.modal_loading = true
      await this.$Api.Project.setGeneralComplaintDoing(this.dataSelected.Tid)
        .then(() => {
          this.$Message.success('操作成功')
          let item = this.data.find(o => o.Tid === this.dataSelected.Tid)
          item.Status = 1
        })
        .catch((err) => {
          this.$Message.error('操作失败！' + err.message)
        })
      this.modal_loading = false
      this.modalDoing = false
    },
    async close () {
      this.modal_loading = true
      await this.$Api.Project.setGeneralComplaintClose(this.dataSelected.Tid)
        .then(() => {
          this.$Message.success('操作成功')
          let item = this.data.find(o => o.Tid === this.dataSelected.Tid)
          item.Status = 3
        })
        .catch((err) => {
          this.$Message.error('操作失败！' + err.message)
        })
      this.modal_loading = false
      this.modalClose = false
    },
    transferSelectCity (value, selectedValue) {
      console.log(value, selectedValue)
      this.transferRegion = value
      if (value && value.length > 0) {
        this.modalTransferModel.Province = parseInt(value.substr(0, 2))
        this.modalTransferModel.Municipality = parseInt(value.substr(2, 2))
        this.modalTransferModel.County = parseInt(value.substr(4, 2))
        this.modalTransferModel.ProvinceName = selectedValue[0].label
        this.modalTransferModel.MunicipalityName = selectedValue[1].label
        this.modalTransferModel.CountyName = selectedValue[2].label
      } else {
        this.modalTransferModel.Province = 0
        this.modalTransferModel.Municipality = 0
        this.modalTransferModel.County = 0
        this.modalTransferModel.ProvinceName = null
        this.modalTransferModel.MunicipalityName = null
        this.modalTransferModel.CountyName = null
      }
    },
    async transfer () {
      this.modal_loading = true
      await this.$Api.Project.transferGeneralComplaint(this.modalTransferModel)
        .then(() => {
          this.$Message.success('操作成功')
          let item = this.data.find(o => o.Tid === this.modalTransferModel.Tid)
          item.Province = this.modalTransferModel.Province
          item.Municipality = this.modalTransferModel.Municipality
          item.County = this.modalTransferModel.County
          item.ProvinceName = this.modalTransferModel.ProvinceName
          item.MunicipalityName = this.modalTransferModel.MunicipalityName
          item.CountyName = this.modalTransferModel.CountyName
          item.RegionFullName = `${this.modalTransferModel.ProvinceName}/${this.modalTransferModel.MunicipalityName}/${this.modalTransferModel.CountyName}`
          this.modalTransferModel = {
            Tid: null,
            Province: null,
            ProvinceName: null,
            Municipality: null,
            MunicipalityName: null,
            County: null,
            CountyName: null
          }
        })
        .catch((err) => {
          this.$Message.error('操作失败！' + err.message)
        })
      this.modal_loading = false
      this.modalTransferConfirm = false
      this.modalTransfer = false
      this.transferRegion = null
    },
    refreshList () {
      // refreshList()
      this.initDataTable()
      this.searchBy = ''
      this.keyword = ''
      this.searchMode = false
      this.tableSearchOn = false
    },
    toggleSearchMode () {
      this.searchMode = !this.searchMode
    },
    toggleSearch (val) {
      this.tableSearchOn = val
    },
    search () {
      if (this.searchBy) {
        this.pageCurrent = 1
        let query = {}
        query[this.searchBy] = this.keyword
        this.initDataTable(query)
      }
    },
    closeDetailModal () {
      this.modalDetail = false
      this.showLightBox = false
      this.dataSelected = {
        Tid: null,
        ComplainantName: null,
        AttachmentImgs: [],
        Attachments: []
      }
    },
    procAttachments (item) {
      let imgArr = []
      let imgSrcArr = []
      let vmInstance = this
      let attachments = item.Attachments
      if (attachments) {
        attachments.split(',').forEach(function (item) {
          let imgObj = {
            FileName: item,
            ImgUrl: ''
          }
          imgArr.push(imgObj)
          vmInstance.getImgUrl(imgObj, function () {
            let imgSrcItem = {
              thumb: imgObj.ImgUrl,
              src: imgObj.ImgUrl,
              caption: '佐证材料'
            }
            imgSrcArr.push(imgSrcItem)
          })
        })
      }
      item.AttachmentImgs = imgArr
      item.ImgSrcArr = imgSrcArr
    },
    getImgUrl (img, callback) {
      if (!img.FileName) {
        img.ImgUrl = require('../../assets/image.png')
      } else {
        this.$Spin.show()
        this.$Api.Aliyun.getFileUrl(img.FileName).then((respBody) => {
          this.$Spin.hide()
          this.$nextTick(function () {
            img.ImgUrl = respBody.replace('-internal', '').replace('http://', 'https://')
          })
          if (callback) {
            this.$nextTick(function () {
              callback()
            })
          }
        })
        .catch(err => {
          this.$Spin.hide()
          this.$Notice.error({
            title: '获取附件失败!',
            desc: err.message
          })
          img.ImgUrl = require('../../assets/image.png')
        })
      }
    },
    openGallery (idx) {
      this.showLightBox = true
      this.$nextTick(() => {
        this.$refs.Lightbox.showImage(idx)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.detail-view {
  .detail-line {
    display: block;
    .title {
      display: inline-block;
    }
    .value {
      display: inline;
    }
  }
}
.status-filter {
  display: inline-block;
  margin-left: 8px;
}
.domain-filter {
  display: inline-block;
  margin-left: 8px;
}
.field-filter {
  display: inline-block;
  margin-left: 8px;
}
.pre {
  white-space: pre-wrap;
}
.report-files {
  margin: 0;
  padding: 0;
  list-style: none;
}
.report-files > .report-file {
  display: inline-block;
  width: 120px;
  height: 120px;
  border: 1px solid #eee;
  background-size: cover;
  background-position: center;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  overflow: hidden;
}
.report-files > .report-file:hover {
  border: 1px solid powderblue;
}
</style>
